import { showPhase } from "./phase";
import {handleFacebookPixel} from "../trackers/facebook";

export const checkUrlParam = urlParam => {
    const params = location.search.substr(1).split('&');
    for (let param in params) {
        const arr = params[param].split('=');
        if (arr[0] === urlParam) {
            return decodeURIComponent(arr[1]);
        }
    }
};

export const handleUrlStatus = () => {
    const status = checkUrlParam('status');
    const firePixel = checkUrlParam('firePixel');
    if (status) {
        if (status === 'success') {
            showPhase('Success');
            if (firePixel === 'true') {
                handleFacebookPixel();
            }
        } else {
            showPhase('Error');
        }
    }
};